import { ca } from '@cian/analytics';
import { IPage, IPageExtra } from '../../types/analytics';
import { TUser } from '../../types/user';

export interface ICallbackClickValues {
  phone: string;
  regionId: number;
  regionName: string;
  searchWishes?: string;
}

interface ITrackCallbackClickParams {
  page: IPage & { extra: IPageExtra };
  user: TUser;
  values: ICallbackClickValues;
  hhConversionId?: string;
}

/**
 * Клик на "Заказать звонок" (успешный ответ от сервера)
 * https://conf.cian.tech/pages/viewpage.action?pageId=1319910433
 * @param {ITrackCallbackClickParams} params - Параметры события
 */
export const trackCallbackClick = ({ page, user, values, hhConversionId }: ITrackCallbackClickParams) => {
  ca('eventSite', {
    action: 'CallBack_popup_send_main_button',
    category: 'newbuilding_finder',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    page,
    user: {
      ...user,
      extra: {
        phone: values.phone,
        region_id: values.regionId,
        region_name: values.regionName,
        search_wishes: values.searchWishes,
        cian_id: hhConversionId,
      },
    },
  });
};
